import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import Box from "@material-ui/core/Box";
import ButtonBase from "@material-ui/core/ButtonBase";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import useStyles from "@hooks/useStyles";

const { SITE_NAME } = process.env;

const RecentActiveLeads = ({ leads = [], job }) => {
	const classes = useStyles("Pro");
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	const items = leads.map((lead, index) => {
		const clientFirstName = lead.client.first_name?.ucFirst();
		const clientFullName = `${clientFirstName} ${lead.client.last_name[0]?.ucFirst()}`;
		const imgSrc = `//static.lessons.com/assets/images/letters/${clientFirstName[0]}.png`;
		const serviceName = lead.service.name;
		const servicePhrase = lead.service.phrase;
		const serviceSingular = lead.service.singular;
		const answers = lead.answers.flatMap((answer) => {
			if (answer.description.toLowerCase() === "message") {
				return [];
			}
			if (answer.description.toLowerCase() === "address") {
				return [];
			}
			return answer.sensitive ? [] : answer.values;
		});
		const answerChips = answers.map((answer) => {
			return (
				<Chip
					key={answer}
					classes={{
						root: classes.leadOpChipRoot,
						label: classes.leadOpChipLabel,
					}}
					label={answer}
				/>
			);
		});
		const timeSinceCreation = moment(lead.created_at).fromNow();
		const timeYMD = moment(lead.created_at).format("YYYY-MM-DD");
		return (
			<Grid item xs={12} key={clientFullName} className={classes.leadsGrid}>
				<ButtonBase
					onClick={scrollToTop}
					className={classes.leadsBox}
					tabIndex={index}
				>
					<Box mr={4}>
						<img src={imgSrc} alt={""} className={classes.leadImg} />
					</Box>
					<div>
						<Box
							component={"h3"}
							textAlign={"left"}
							mt={1}
							fontSize={18}
							mb={3}
						>
							<span className={classes.leadOpName}>{clientFullName}.</span>{" "}
							<Box component={"span"} fontWeight={400}>
								is looking for a
							</Box>{" "}
							<span className={classes.leadOpName}>
								{job ? job : ""}{" "}
								{serviceSingular ? serviceSingular : servicePhrase}
							</span>
						</Box>

						<Box fontSize={14}>
							{/* <Box component={"div"} display={"flex"} alignItems={"center"}>
								<LocationOnOutlinedIcon />
								<Box ml={3}>Las Vegas, NV 69696</Box>
							</Box> */}

							<Box
								component={"div"}
								display={"flex"}
								alignItems={"center"}
								mt={3}
							>
								<MonetizationOnOutlinedIcon />
								<Box ml={3}>
									{SITE_NAME === "tutors"
										? "Earn $25 – $70/hr"
										: "Sign up to contact"}
								</Box>
							</Box>

							<Box
								component={"div"}
								display={"flex"}
								alignItems={"flex-start"}
								mt={3}
							>
								<InfoOutlinedIcon />
								<Box
									ml={3}
									lineHeight={1.5}
									display={"-webkit-box"}
									className={classes.leadListingText}
									overflow={"hidden"}
								>
									{answerChips}
								</Box>
							</Box>
						</Box>
					</div>
					<Box
						display={{ xs: "none", sm: "block" }}
						position={"absolute"}
						className={classes.leadTime}
					>
						<time dateTime={timeYMD}>{timeSinceCreation}</time>
					</Box>
				</ButtonBase>
			</Grid>
		);
	});
	return items;
};

RecentActiveLeads.propTypes = {
	leads: PropTypes.arrayOf(
		PropTypes.shape({
			client: PropTypes.shape({
				first_name: PropTypes.string,
				last_name: PropTypes.string,
			}),
			service: PropTypes.shape({
				phrase: PropTypes.string,
			}),
			answers: PropTypes.arrayOf(
				PropTypes.shape({
					values: PropTypes.arrayOf(PropTypes.string),
				})
			),
		})
	),
};

export default RecentActiveLeads;
